import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function RegisterSeeker() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { register, reset, handleSubmit, errors, getValues } = useForm();

  const signUpSeeker = (value) => {
    axios.post("/api/seeker/register", value).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status == "success") {
        reset();
        history.push("/login-seeker");
      }
    });
  };

  return (
    <div className="section-full p-t120 p-b60 site-bg-light pattern-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/LoginBGImg-Photoroom.png" alt="info image" />
            </figure>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="twm-log-reg-form-wrap">
              <h2 className="wt-title">Welcome to Solid Future</h2>
              <p className="twm-log-reg-subtitle">
                Boost your hiring success with a streamlined and user friendly job application system.
              </p>
              <div className="radio_tabs">
                <ul>
                  <li>
                  <Link to="/login-seeker">Login</Link>
                  </li>
                  <li >
                    <Link to="/register-seeker">Register</Link>
                  </li>
                </ul>
              </div>
              <form onSubmit={handleSubmit(signUpSeeker)}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="username"
                        type="text"
                        id="seeker-username"
                        className={`form-control ${
                          errors.username !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Full Name"
                        ref={register({
                          required: "Please enter a full name",
                        })}
                        autoComplete="name"
                      />
                      {errors.username && (
                        <div id="seeker-usernameFeedback" className="text-danger">
                          {errors.username.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="email"
                        type="email"
                        id="seeker-email"
                        className={`form-control ${
                          errors.email !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Email"
                        ref={register({
                          required: "Please provide a valid email.",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors.email && (
                        <div id="emailFeedback" className="text-danger">
                          {errors.email.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div
                      className="form-group mb-3 position-relative"
                      id="seeker-passwords-group"
                    >
                      <input
                        name="password"
                        type="password"
                        id="seeker-passwords"
                        className={`form-control ${
                          errors.password !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Password"
                        ref={register({
                          required: "Password field is required",
                          pattern: {
                            value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/i,
                            message:
                              "The password must be at least 8 characters long and contain at least one uppercase letter, digit and a special character",
                          },
                          minLength: {
                            value: 8,
                            message:
                              "The password must be at least 8 characters long and contain at least one uppercase letter, digit and a special character",
                          },
                        })}
                      />
                      <div
                        className="showPassword"
                        data-relative="#seeker-passwords-group"
                        data-formid="#seeker-passwords"
                        data-show="false"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="ri-eye-fill"></i>
                      </div>
                      {errors.password && (
                        <div
                          id="seekerPasswordFeedback"
                          className="text-danger"
                        >
                          {errors.password.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div
                      className="form-group position-relative mb-3"
                      id="seeker-passwords_confirmation-group"
                    >
                      <input
                        name="password_confirmation"
                        type="password"
                        id="seeker-passwords_confirmation"
                        className={`form-control ${
                          errors.password_confirmation !== undefined
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Confirm Password"
                        ref={register({
                          required: "Please confirm your password",
                          validate: (value) =>
                            value === getValues("password") ||
                            "Password does not match",
                        })}
                      />
                      <div
                        className="showPassword"
                        data-relative="#seeker-passwords_confirmation-group"
                        data-formid="#seeker-passwords_confirmation"
                        data-show="false"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "5px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="ri-eye-fill"></i>
                      </div>
                      {errors.password_confirmation && (
                        <div
                          id="seeker-password_confirmationFeedback"
                          className="text-danger"
                        >
                          {errors.password_confirmation.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="mobile"
                        type="number"
                        id="seeker-mobile"
                        className={`form-control ${
                          errors.mobile !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Mobile"
                        ref={register({
                          required: "Please enter a mobile number",
                          minLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits long",
                          },
                          maxLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits long",
                          },
                        })}
                      />
                      {errors.mobile && (
                        <div
                          id="seeker-mobileFeedback"
                          className="text-danger"
                        >
                          {errors.mobile.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <div className=" form-check">
                        <input
                          type="checkbox"
                          name="terms_condition"
                          className={`form-check-input ${
                            errors.terms_condition !== undefined
                              ? "is-invalid"
                              : ""
                          }`}
                          id="seeker-acceptTerms"
                          defaultValue="Y"
                          ref={register({
                            required: "Required",
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="seeker-acceptTerms"
                        >
                          I agree to the{" "}
                          <Link to={`/pages/terms-and-conditions`} target="_blank">Terms and conditions</Link> and 
                          <Link to={`/pages/privacy-policy`} target="_blank"> Privacy Policy</Link>
                        </label>
                        <p>
                          Already registered? 
                           <Link to="/login-seeker"> Log in here </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <button type="submit" className="site-button">
                      Sign Up
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
